<ng-container *transloco="let t;">
<ng-scrollbar autoHeightDisabled="false" visibility="hover" class="contract-control-category-tab-scroll">
    <div class="row m-0 pb-1 mt-0">
        <div class="contract-type-settings-headline px-2 mt-75 py-1 pb-2 border-bottom">
            <h4 class="mb-0 font-medium-1 mb-50">{{ t('Document type setting - modal - Documents layout tab title (Document type section) - Documents layout') }}</h4>
            <p class="mb-0">{{ t('Documents layout heading sub title (Document type section) - Customize how you want your document layout to look for HR documents', { 
    documentType: documentTypeSettings?.document_type || ''
            }) }}</p>
        </div>
        <div class="px-1 mt-1">
            <app-overview-group 
                (updateFieldsOrders)="updateFieldsOrders($event)" 
                [allowSectionDragAndDrop]="true"
                [allowVisibilityChange]="true"
                (updateGroupsOrders)="updateGroupsOrders($event)" 
                [groups]="((layoutsetting | extractDocumentTypeSectionData: DocumentTypeSectionEnum.DocumentLayout)?.groups ?? []) |  sortByOrder: 'order'"
                [disabledAccordionSection]="disabledAccordionSection"
            
            ></app-overview-group>
        </div>
    </div>
</ng-scrollbar>
<div class="modal-footer border-top pt-2">
    <button type="button" class="btn btn-outline-secondary" (click)="closeSidebar.emit()" rippleEffect>{{ t('Cancel button text (cancel button) - cancel') }}</button>
    <button type="submit" class="btn btn-primary" (click)="updateLayoutSettings()" rippleEffect><span *ngIf="saveBtnLoader === 'document_preview'" class="spinner-border spinner-border-sm me-1"></span> {{ t('Save button text (save button) - save')}}</button>
</div>
</ng-container>